import { COMPANY, NAV } from "../../data/site";

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#FAF6EE] text-[#0A0A0A] border-t border-black/15"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div className="font-mono-ibm text-[11px] uppercase tracking-widest text-[#2F6B1F]">
              {COMPANY.short}
            </div>
            <div className="mt-4 font-display text-[18vw] md:text-[14vw] lg:text-[180px] leading-[0.85] tracking-tighter font-medium">
              <span className="text-[#0A0A0A]">MB </span>
              <span className="text-[#2F6B1F]">PRISM</span>
              <span className="text-[#FF331F]">.</span>
            </div>
            <img
              src="/brand/mbprism-logo.png"
              alt="MB Prism Software Solutions Ltd."
              className="mt-8 h-9 w-auto"
            />
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="text-[11px] uppercase tracking-widest text-[#404040] font-mono-ibm">
                Sitemap
              </div>
              <ul className="mt-4 space-y-2">
                {NAV.map((n) => (
                  <li key={n.id}>
                    <button
                      data-testid={`footer-nav-${n.id}`}
                      onClick={() => scrollTo(n.id)}
                      className="text-sm text-[#0A0A0A] hover:text-[#2F6B1F] transition-colors"
                    >
                      {n.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-widest text-[#404040] font-mono-ibm">
                Office
              </div>
              <div className="mt-4 text-sm text-[#0A0A0A] leading-relaxed">
                {COMPANY.address.line1}
                <br />
                {COMPANY.address.line2} {COMPANY.address.postal}
                <br />
                {COMPANY.address.country}
              </div>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-widest text-[#404040] font-mono-ibm">
                Direct
              </div>
              <div className="mt-4 text-sm leading-relaxed">
                <a
                  href={`tel:${COMPANY.phone.replace(/[^+\d]/g, "")}`}
                  className="block text-[#0A0A0A] hover:text-[#2F6B1F]"
                  data-testid="footer-phone"
                >
                  {COMPANY.phone}
                </a>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="block text-[#0A0A0A] hover:text-[#2F6B1F] mt-2"
                  data-testid="footer-email"
                >
                  {COMPANY.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-black/15 flex flex-col md:flex-row justify-between gap-4 font-mono-ibm text-xs text-[#404040]">
          <div>{COMPANY.legal}</div>
          <div className="flex items-center gap-6">
            <span>Ottawa, ON</span>
            <span>—</span>
            <span>Crafted with rigour</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
